"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _context = _interopRequireDefault(require("../context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

;
;

function useTreble(context) {
  try {
    if (context) {
      if (_typeof(context) !== "object") {
        throw new TypeError("TrebleGSM: useTreble hook must only accept React.Context.");
      }
    }

    var trebleContext = context !== undefined ? context : _context["default"];
    var storeSubscription = (0, _react.useContext)(trebleContext);

    if (storeSubscription === null) {
      throw new Error('TrebleGSM: StoreSubscription is null. Dependency React might be missing.');
    }

    return storeSubscription;
  } catch (error) {
    throw new Error(error);
  }
}

;
var _default = useTreble;
exports["default"] = _default;
module.exports = exports.default;